import { NotificationText } from "./styles";

export default function Notification({ message }) {
  return <NotificationText>{message}</NotificationText>;
}
